import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import {userOption, userResult} from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import orderServices from '../../services/orders/orderservice';

interface SearchPanelProps {
  onSearch: (query: any) => void;
  setLoading: (loading: boolean) => void;
}

const GSTSalesReportsListSearch: React.FC<SearchPanelProps> = ({ onSearch, setLoading }) => {

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [startDate, setStartDate] = useState<any>(yesterday);
    const [endDate, setEndDate] = useState<any>(today);
    const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: ''},];
    const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
    const [orderUser, setOrderUser] = useState<userResult[]>([]);
    const [selectedUser, setSelectedUser] = useState<number>(0);
    const [invoiceNo, setInvoiceNo] = useState<any>("");
    const [pageNumber,setPageNumber] = useState<number>(1);
    const [pageSize,setPageSize] = useState<number>(10);

    const handleDropdownChange = (e: DropdownChangeEvent) => {
        setSelectedUser(e.value);
    }

    const handleDropdownFilter = (e: DropdownFilterEvent) => {
        if(e.filter.length>2){
            orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
                if(response.length>0){
                    setOrderUsers(response)
                }        
            })
        }
    }

    useEffect(() => {
        const searchFilter = {
            "userId" : selectedUser,
            "invoiceNo" : Number(invoiceNo),
            "fromDate" : startDate,
            "toDate" :  endDate,
            "pageSize" : pageSize,
            "pageNumber" : pageNumber
        }
        onSearch(searchFilter);
    }, []);

    useEffect(() => {              
        setOrderUser(orderUsers.map((user) => ({
            userID: user.userID,
            detail: user.userID > 0 ? `${user.name}, ${user.primaryContactNbr}` : "",
        })));
    }, [orderUsers]);

        const handleSearch = () => {
             setLoading(true)
            const searchFilter = {
            "userId" : selectedUser ,
            "invoiceNo" : Number(invoiceNo),
            "fromDate" : startDate,
            "toDate" :  endDate,
            "pageSize" : pageSize,
            "pageNumber" : pageNumber
        }
        onSearch(searchFilter);    
    }    

    return(
          <div className="col card border-noround p-2">
            <div className='grid'>
                <div className="col-12 sm:col-3 lg:col-3 font-bold text-white border-round">
                    <Dropdown
                        id="SearchUser"
                        name="SearchUser"                                                      
                        options={orderUser}
                        optionLabel="detail"
                        optionValue="userID"
                        value={selectedUser}
                        onChange={handleDropdownChange}
                        onFilter={handleDropdownFilter} filter
                        placeholder="Search for User/Mobile" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-3 lg:col-3 font-bold text-white border-round">
                    <InputText
                        id="OrderNo"
                        name="OrderNo"
                        keyfilter="int"
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                        placeholder={invoiceNo + "#"} style={{ width: "100%" }}
                    />
                </div>  
                 <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <Calendar value={startDate}  onChange={(e) => setStartDate(e.value)}
                    dateFormat="dd/mm/yy" style={{ width: "50%" }}
                    placeholder="start date"/>
                    <Calendar value={endDate}  onChange={(e) => setEndDate(e.value)}
                    dateFormat="dd/mm/yy" style={{ width: "50%" }}
                    placeholder="end date"/>
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round pl-8 pr-8">
                    <Button className=" text-black border-round" style={{ width: "100%" }} onClick={handleSearch}  severity="success">Filter</Button>
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round pl-8 pr-8 mb-12 sm:mb-0 -mt-6 sm:mt-0">
                    <Button className="text-black border-round" style={{ width: "100%" }}  severity="secondary" text raised>
                        Reset
                    </Button>
                </div>
         </div>
         </div>
    )

}

export default GSTSalesReportsListSearch;
